import { Fragment } from "react"
import type { SearchResult } from "@/schema/search"
import { Badge, CommandGroup, CommandItem, CommandSeparator } from "@ui/shad"

import { getRecordTypeLabel, groupSearchResults, resultKey } from "./utils"

export function CommandResultGroups({
  groups,
  onItemSelect,
}: {
  groups: ReturnType<typeof groupSearchResults>
  onItemSelect: (item: SearchResult) => void
}) {
  return groups.map((group, index) => (
    <Fragment key={group.label}>
      {index > 0 && <CommandSeparator alwaysRender />}
      <CommandGroup heading={group.label}>
        <CommandItems results={group.results} onItemSelect={onItemSelect} />
      </CommandGroup>
    </Fragment>
  ))
}

interface CommandItemsProps {
  results: SearchResult[]
  onItemSelect?: (item: SearchResult) => void
}

export function CommandItems({ results, onItemSelect }: CommandItemsProps) {
  const hasResults = results.length > 0

  if (hasResults) {
    return (
      <>
        {results.map((result) => {
          const key = resultKey(result)
          return (
            <CommandItem key={key} value={key} onSelect={() => onItemSelect?.(result)}>
              <div className="flex w-full items-center justify-between">
                <span className="truncate">{result.display_label || "No label"}</span>
                <Badge variant="outline" size="sm" className="shrink-0">
                  {getRecordTypeLabel(result.type)}
                </Badge>
              </div>
            </CommandItem>
          )
        })}
      </>
    )
  }

  return null
}
